import moment from "moment";
import React, { useEffect, useRef, useMemo, useState } from "react";
import { useParams } from "react-router";
import {
  getCustomerPressureUsage,
  getCustomersDetail,
} from "src/main_app/services/apis";
import { map, last, isEmpty, isNil } from "ramda";
import { customerHasSumsData } from "src/main_app/services/apis";

import { addDays, convertDate, isNotNil } from "../../../../utils/common";

import CustomersUsageSkeleton from "./customers-pressure-usage-skeleton";
import CustomersPressureUsagePage from "./customers-pressure-usage-page";

import { authService } from "src/base/services";
import { getApiUrl } from "src/main_app/utils/config-utility";
import axios from "axios";

export default (props) => {

  const ticksRef = useRef([]);
  const params = useParams();
  const [customer, setCustomer] = useState(null);

  const [hasRealtimeData, setHasRealtimeData] = useState(false);
  const [dataWeekly, setDataWeekly] = useState(null);
  const [meterNames, setMeterNames] = useState([]);
  const [fromDateSumsData, setFromDateSumsData] = useState(null);
  const [toDateSumsData, setToDateSumsData] = useState(null);
  const [toDateCsvFile, setToDateCsvFile] = useState(null);
  const [fromDateCsvFile, setFromDateCsvFile] = useState(null);
  const [skeleton, setSkeleton] = useState(true);
  const [dataSite, setDataSite] = useState(null);

  const dateRangeDataWeekly = useMemo(() => {
    const today = new Date();
    const toDate = addDays(today, -1);
    const fromDate = addDays(today, -8);
    return [fromDate, toDate];
  }, []);

  const getDataWeekly = async (from, to) => {
    const ticks = [];
    const {
      data: { data, dataSite: apiDataSite },
    } = await getCustomerPressureUsage(params.id, {
      from: convertDate(from || dateRangeDataWeekly[0]),
      to: convertDate(to || dateRangeDataWeekly[1]),
      type: "pressure",
    });

    // Set dataSite from API response
    if (apiDataSite) {
      setDataSite(apiDataSite);
    }

    if (!isNil(from)) {
      setFromDateSumsData(moment(from).utc().format("YYYY-MM-DD HH:mm:ss"));
      setToDateSumsData(moment(to).utc().format("YYYY-MM-DD HH:mm:ss"));
      setToDateCsvFile(moment(to).utc().format("YYYY-MM-DD"));
      setFromDateCsvFile(moment(from).utc().format("YYYY-MM-DD"));
    } else {
      const formatToDate = convertDate(dateRangeDataWeekly[1]) + " 23:59:00";
      setFromDateSumsData(convertDate(dateRangeDataWeekly[0]));
      setToDateSumsData(formatToDate);
      setToDateCsvFile(convertDate(dateRangeDataWeekly[1]));
      setFromDateCsvFile(convertDate(dateRangeDataWeekly[0]));
    }

    const allMeterNames = [];

    let arrDataWeekly = map((item) => {
      const { time, ...metersData } = item;

      if (isEmpty(metersData)) return { time };

      const utcTime = moment(time).utcOffset(0, true);
      const utcUnix = utcTime.unix();

      if (isEmpty(ticks) || utcUnix - last(ticks) >= 86400) {
        ticks.push(utcUnix);
      }

      const combinedData = {
        date: utcUnix,
        displayDate: utcTime.format("ddd MMM DD hh:mm a"),
      };

      for (const meterName in metersData) {
        if (!Object.hasOwnProperty.call(metersData, meterName)) continue;
        allMeterNames.push(meterName);
        const sumUsage = metersData[meterName];
        combinedData[meterName] = sumUsage
          ? Math.round(sumUsage * 100) / 100
          : // ? Math.round(sumUsage * 10) / 10
            null;
      }

      ticksRef.current = ticks;

      return combinedData;
    }, data);

    const setOfMeterNames = [...new Set(allMeterNames)];
    setMeterNames(setOfMeterNames);

    arrDataWeekly = map((item) => {
      for (const meterName of setOfMeterNames) {
        if (isNotNil(item[meterName])) continue;
        item[meterName] = 0;
      }

      return item;
    }, arrDataWeekly);

    setDataWeekly(arrDataWeekly);
  };

  const handleDownloadDataPressure = () => {
    // download
    const name = props.customerName;
    axios
      .get(
        `${getApiUrl()}/export/sums-data/csv?&token=${authService.getAccessToken()}&from=${fromDateSumsData}&to=${toDateSumsData}&customer_id=${
          params.id
        }&type=pressure`,
        {
          responseType: "blob",
        }
      )
      .then((res) =>
        saveAs(res.data, `${name}_${fromDateCsvFile}_${toDateCsvFile}.csv`)
      );
  };

  const getAddressCustomer = async () => {
    const { data: data } = await getCustomersDetail(params.id);
    const custometObj = data.data;
    setCustomer(custometObj);
  };

  useEffect(() => {
    getAddressCustomer();
    Promise.all([customerHasSumsData(params.id)]).then(
      ([
        {
          data: { data },
        },
      ]) => {
        if (data[0].has_sums_data) {
          setHasRealtimeData(true);
          getDataWeekly().then(() => setTimeout(() => setSkeleton(false), 200));
        } else {
          setTimeout(() => setSkeleton(false), 200);
        }
      }
    );
  }, []);

  if (skeleton) return <CustomersUsageSkeleton />;

  return (
    <CustomersPressureUsagePage
      hasRealtimeData={hasRealtimeData}
      dateRangeDataWeekly={dateRangeDataWeekly}
      getDataWeekly={getDataWeekly}
      dataWeekly={dataWeekly}
      meterNames={meterNames}
      handleDownloadDataPressure={handleDownloadDataPressure}
      ticks={ticksRef.current}
      customer={customer}
      dataSite={dataSite}
    />
  );
};
